var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTranslate(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 34.404,
    height: 35,
    viewBox: "0 0 34.404 35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6508",
    "data-name": "Rectangle 6508",
    width: 34.108,
    height: 35,
    fill: "currentColor"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_16787",
    "data-name": "Group 16787",
    transform: "translate(-1472.116 -161.638)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_25171",
    "data-name": "Path 25171",
    d: "M199.543,78.118h0Z",
    transform: "translate(1293.287 91.941)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_16783",
    "data-name": "Group 16783",
    transform: "translate(1472.413 161.638)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16783-2",
    "data-name": "Group 16783",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_25182",
    "data-name": "Path 25182",
    d: "M19.008,14.544V1.889A1.891,1.891,0,0,0,17.119,0H1.889A1.891,1.891,0,0,0,0,1.889V17.821a1.891,1.891,0,0,0,1.889,1.889H14.544V15.921a1.378,1.378,0,0,1,1.377-1.377Zm-4.976,1.377V19.2H1.889A1.378,1.378,0,0,1,.512,17.821V1.889A1.378,1.378,0,0,1,1.889.512h15.23A1.379,1.379,0,0,1,18.5,1.889V14.032H15.921a1.891,1.891,0,0,0-1.889,1.889",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25183",
    "data-name": "Path 25183",
    d: "M164.622,149.366h-15.23a1.891,1.891,0,0,0-1.889,1.889v15.932a1.891,1.891,0,0,0,1.889,1.889h15.23a1.891,1.891,0,0,0,1.889-1.889V151.255a1.891,1.891,0,0,0-1.889-1.889m0,19.2h-15.23a1.379,1.379,0,0,1-1.377-1.377V151.255a1.379,1.379,0,0,1,1.377-1.377h15.23A1.379,1.379,0,0,1,166,151.255v15.932a1.379,1.379,0,0,1-1.377,1.377",
    transform: "translate(-132.403 -134.075)",
    fill: "currentColor"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_16785",
    "data-name": "Group 16785",
    transform: "translate(1475.052 164.763)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16786",
    "data-name": "Group 16786",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_25184",
    "data-name": "Path 25184",
    d: "M11.022,1.714h3.569v-.1H8.3A1.361,1.361,0,0,0,7.223,1a1.506,1.506,0,0,0-1.048.613H1v.1H6.231l.016-.022a1.452,1.452,0,0,1,.98-.591,1.28,1.28,0,0,1,1,.594l.016.02h2.671A14.25,14.25,0,0,1,6.928,8.355,12.332,12.332,0,0,1,3.879,3.347l-.1.022A12.436,12.436,0,0,0,6.854,8.427a19.587,19.587,0,0,1-4.143,3.079l.055.085A19.81,19.81,0,0,0,6.928,8.5a15,15,0,0,0,4.432,3.092l.047-.089A14.9,14.9,0,0,1,7,8.43,16.4,16.4,0,0,0,9.615,5.107a11.808,11.808,0,0,0,1.408-3.393",
    transform: "translate(-1 -1.001)",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25185",
    "data-name": "Path 25185",
    d: "M11.022,1.714h3.569v-.1H8.3A1.361,1.361,0,0,0,7.223,1a1.506,1.506,0,0,0-1.048.613H1v.1H6.231l.016-.022a1.452,1.452,0,0,1,.98-.591,1.28,1.28,0,0,1,1,.594l.016.02h2.671A14.25,14.25,0,0,1,6.928,8.355,12.332,12.332,0,0,1,3.879,3.347l-.1.022A12.436,12.436,0,0,0,6.854,8.427a19.587,19.587,0,0,1-4.143,3.079l.055.085A19.81,19.81,0,0,0,6.928,8.5a15,15,0,0,0,4.432,3.092l.047-.089A14.9,14.9,0,0,1,7,8.43,16.4,16.4,0,0,0,9.615,5.107,11.808,11.808,0,0,0,11.022,1.714Z",
    transform: "translate(-1 -1.001)",
    fill: "currentColor",
    stroke: "currentColor",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_25186",
    "data-name": "Path 25186",
    d: "M196.694,40.977a11.5,11.5,0,0,0-7.575-.83l1.144-1.187-.113-.109-1.5,1.56,1.8.842.066-.142-1.6-.749.008-.009a11.122,11.122,0,0,1,7.7.761c2.555,1.412,4.252,4.114,5.042,8.032l.154-.031c-.8-3.965-2.522-6.7-5.12-8.138",
    transform: "translate(1303.862 124.206)",
    fill: "currentColor",
    stroke: "currentColor",
    strokeLinejoin: "round",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25187",
    "data-name": "Path 25187",
    d: "M8.047,2.126A11.5,11.5,0,0,0,.472,1.3L1.616.109,1.5,0,0,1.56,1.8,2.4l.066-.142-1.6-.749L.273,1.5a11.122,11.122,0,0,1,7.7.761c2.555,1.412,4.252,4.114,5.042,8.032l.154-.031c-.8-3.965-2.522-6.7-5.12-8.138",
    transform: "matrix(-0.978, -0.208, 0.208, -0.978, 1485.292, 195.232)",
    fill: "currentColor",
    stroke: "currentColor",
    strokeLinejoin: "round",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25188",
    "data-name": "Path 25188",
    d: "M213.3,195.685l.094-.037-4.188-10.607-4.182,10.607.094.037,1.9-4.824h4.375Zm-6.24-4.926,2.146-5.443,2.149,5.443Z",
    transform: "translate(1288.462 -3.889)",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.5
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTranslate);
export default __webpack_public_path__ + "static/media/translate.c6d65c97bc69621b8941f77909bf39fe.svg";
export { ForwardRef as ReactComponent };